export const DefaultFabStyle = {
    position: 'fixed',
    bottom: 16,
    right: 16,
};
